import {
  AccountFlagEnum,
  ProductFeatureEnum,
  useUsageDashboardFeaturesListQuery,
} from '~/generated/graphql';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

export const useCreditUsage = () => {
  const { data, loading, error } = useUsageDashboardFeaturesListQuery();

  const freeTierDefaultCredits = 500;

  const hasUsageFlag = useFeatureFlag(AccountFlagEnum.XShowUsageOnPlatform)
    .enabled;

  const productFeature = data?.productFeatures.find(
    (item) =>
      item.id === ProductFeatureEnum.FreeTier ||
      item.id === ProductFeatureEnum.PaidTier ||
      item.id === ProductFeatureEnum.BusinessTier ||
      item.id === ProductFeatureEnum.HubspotFreeTier ||
      item.id === ProductFeatureEnum.HubspotPaidTier,
  );

  const isHubspotAccount =
    productFeature?.id === ProductFeatureEnum.HubspotFreeTier ||
    productFeature?.id === ProductFeatureEnum.HubspotPaidTier;
  const isFreeAccount =
    productFeature?.id === ProductFeatureEnum.FreeTier ||
    productFeature?.id === ProductFeatureEnum.HubspotFreeTier;
  const isPaidAccount =
    productFeature?.id === ProductFeatureEnum.PaidTier ||
    productFeature?.id === ProductFeatureEnum.HubspotPaidTier;

  const credits = productFeature?.usageLimit as number;
  const creditsUsed =
    productFeature?.currentPeriodTotalUsage.total?.credits || 0;
  const hasCredits = !!credits;
  const hasUsage = (hasUsageFlag || hasCredits) && !error;

  return {
    credits,
    creditsUsed,
    freeTierDefaultCredits,
    hasCredits,
    hasUsage,
    isFreeAccount,
    isHubspotAccount,
    isPaidAccount,
    loading,
    planId: productFeature?.id,
  };
};
